<template>
  <div v-if="actingCommittee" class="acting-committee-bar bg-warning text-dark px-4 py-2 d-flex flex-wrap align-items-center">
    <span class="mr-3">Working on committee: <strong>{{ actingCommittee.name }}</strong></span>
    <a href="#" class="text-primary font-weight-bold acting-committee-bar__return" @click.prevent="returnToOwnCommittee">Return to my committee</a>
  </div>
</template>

<script>
import useUserRole from '@/composables/useUserRole'
import { getActingCommittee, setActingCommittee } from '@/services/actingCommittee'

// CAM-1533: shown only while a Super Secretary works on a committee other than their own.
// Sticky: sits right under the top bar and stays pinned to the top of the viewport once the top
// bar has scrolled away.
export default {
  name: 'ActingCommitteeBar',
  computed: {
    // Not reactive to localStorage — re-read on every route change via `$route`
    actingCommittee() {
      // eslint-disable-next-line no-unused-expressions
      this.$route
      return useUserRole().isActingForOtherCommittee ? getActingCommittee() : null
    }
  },
  methods: {
    // Back to the committee list, ready to pick another committee
    returnToOwnCommittee() {
      setActingCommittee(null)
      window.location.assign('/switch-committee')
    }
  }
}
</script>

<style scoped>
.acting-committee-bar {
  position: sticky;
  top: 0;
  z-index: 1030;
}

.acting-committee-bar__return {
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/components/ActingCommitteeBar.vue